// Click Albania's own details, taken from clickapp.win — none of it is
// invented. Shared by the partner section and the partner modal so the number,
// the address and the service list can never drift apart between the two.
import { Globe, QrCode, Building2, Code2 } from 'lucide-react';

export const CLICK = {
  name: 'Click Albania',
  phone: '+355 69 25 70 455',
};

// Labels double as i18n keys (see src/translation/*.json).
export const CLICK_SERVICES = [
  { icon: Globe, label: 'Website & Web App Development' },
  { icon: QrCode, label: 'Digital Menu & QR Ordering' },
  { icon: Building2, label: 'Hotel Management Systems' },
  { icon: Code2, label: 'Custom Business Software' },
];
